export enum SSE_READY_STATES {
  CLOSED = 2,
  OPEN = 1,
  CONNECTION = 0,
}
